/**
 * Scrolt naar de afspraak-planner sectie op de huidige pagina.
 * Staat die er niet, dan navigeren we naar /kennismaken.
 */
export const scrollToPlanner = () => {
  const el =
    document.getElementById("ontdek-omzet") ||
    document.getElementById("gesprek-inplannen") ||
    document.querySelector("[data-planner-section]");

  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
    return;
  }

  window.location.href = "/kennismaken";
};
